import { render, staticRenderFns } from "./CustomersTableExport.vue?vue&type=template&id=10c79a6d&"
import script from "./CustomersTableExport.vue?vue&type=script&lang=js&"
export * from "./CustomersTableExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports